import { skipToken } from '@apollo/client/react'
import { useLocalStorage } from '@mantine/hooks'
import { useCallback } from 'react'
import { NotificationType } from 'src/services/apollo/generated/graphql'
import { useListNotifications } from 'src/services/apollo/notification'
import { getNodesFromConnection } from 'src/utils/graphql'
import { useCheckTokenForArgs } from 'src/utils/token'

export function useUnreadNotificationNews() {
  const [lastRead, setLastRead] = useLocalStorage<number>({
    key: 'last-read-news',
  })
  const input = useCheckTokenForArgs({
    last: 1,
    type: NotificationType.News,
  })
  const { data: notisData } = useListNotifications(input ?? skipToken)

  const notis = getNodesFromConnection(notisData)
  const lastCreatedAt = notis?.[0]?.createdAt
    ? new Date(notis[0].createdAt).getTime()
    : undefined

  const hasUnread = (lastRead ?? 0) < (lastCreatedAt ?? 0)

  const updateLastRead = useCallback(() => {
    setLastRead(new Date().getTime())
  }, [])

  return { hasUnread, updateLastRead }
}
